<template>
  <div />
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      sateliteIsReady: false
    };
  },

  mounted() {
    this.isDTMReady();
  },
  computed: {
    ...mapState({
      dtm: state => state.dtm
    })
  },
  methods: {
    isDTMReady() {
      // We need to wait to that DTM is set before it to run the script on the footer
      if (!this.dtm) {
        setInterval(() => {
          if (window._satellite && !this.dtm) {
            _satellite.pageBottom();
            // // update the status globably as a shared rule to start any ATM Script
            this.$store.commit("SET_DTM", true);
            console.log(`_satellite is mounted`);
            console.log(_satellite);
          }
        }, 500);
      }
    }
  }
};
</script>

<style>
</style>
